import { styled } from '@mui/material';

export const SidebarContainer = styled('div', {
  shouldForwardProp: (prop) =>
    !['baseValue', 'scrollTop', 'minMaxNecessary'].includes(prop as string),
})(({ theme, baseValue, scrollTop, minMaxNecessary }) => ({
  position: 'sticky',
  top: `${baseValue}px`,
  overflowY: 'auto',
  ...(() => {
    if (minMaxNecessary) {
      return {
        minHeight: `calc(100vh - ${theme.spacings.unit(scrollTop / 4)})`,
        maxHeight: `calc(100vh - ${theme.spacings.unit(scrollTop / 4)})`,
      };
    } else return {};
  })(),
}));

export const Section = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: '3rem',
}));

export const LinkStyled = styled('a', {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
  color: theme.colors.black,
  cursor: 'pointer',
  textDecoration: 'none',
  wordBreak: 'break-word',
  '&::first-letter': {
    textTransform: 'capitalize',
  },
  ':hover': {
    color: theme.colors.primary,
  },
  ...(active && { fontWeight: '600' }),
}));

export const SectionTitle = styled('p')(({ theme }) => ({
  width: '100%',
  margin: '0px',
  fontSize: `${theme.fonts.utility.size(24 / 2)}`,
  fontWeight: '600',
  wordBreak: 'break-word',
  '&::first-letter': {
    textTransform: 'capitalize',
  },
}));

export const SectionList = styled('ul')(({ theme }) => ({
  width: '100%',
  listStyle: 'none',
  padding: '0px',
}));

export const SectionListVoice = styled('li')(({ theme }) => ({
  width: '100%',
  lineHeight: '1.75rem',
  margin: `${theme.spacings.unit(1)} 0`,
}));
